import React from 'react';
import './invoice-details.css';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ReactHtmlParser from 'react-html-parser';

class InvoiceDetails extends React.Component {

    constructor(props) {
        super(props);
        this.invoice = this.props.invoice;
        this.showItineraryButton = this.props.showItineraryButton;
        this.showInvoiceDisclaimer = this.props.showInvoiceDisclaimer;
        this.state = {
            acceptTermsAndConditionsButtonDisabled: false,
            showTermsAndConditionsPopup: false,
            termsAndConditionsAccepted: this.invoice.termsAndConditionsAccepted
        };
    }

    render = () => {
        return (
            <div
                className="invoice-details">
                <Modal size="lg" show={this.state.showTermsAndConditionsPopup} onHide={this.cancelTermsAndConditions}>
                    <Modal.Header closeButton>
                        <Modal.Title>Terms And Conditions</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {ReactHtmlParser(this.invoice.termsAndConditionsMarkup)}
                    </Modal.Body>
                    <Modal.Footer>
                        {!this.state.termsAndConditionsAccepted &&
                        <div class="rea-block-12">
                            <a className="rea-printBtn rea-textLink" onClick={e=>{e.preventDefault();this.openPrintVersion()}} href="# "><i
                                className="fa fa-print"></i> Print</a>
                            <Button variant="secondary" className="rea-floatRight rea-cancelBtn"
                                    onClick={this.cancelTermsAndConditions}
                                    disabled={this.state.acceptTermsAndConditionsButtonDisabled}>
                                Cancel
                            </Button>
                            {
                                !this.state.acceptTermsAndConditionsButtonDisabled &&
                                <Button variant="primary" className="rea-floatRight" onClick={this.handleSubmit}
                                        disabled={this.state.termsAndConditionsAccepted || !this.invoice.termsAndConditionsAcceptanceUrl}>
                                    I Agree
                                </Button>
                            }
                            {
                                this.state.acceptTermsAndConditionsButtonDisabled &&
                                <Button variant="primary" className="rea-floatRight"
                                        disabled={true}>
                                    Processing
                                </Button>
                            }
                        </div>
                        }

                        {this.state.termsAndConditionsAccepted &&
                        <div class="rea-block-12">
                            <a className="rea-printBtn rea-textLink" onClick={e=>{e.preventDefault();this.openPrintVersion()}} href="# "><i
                                className="fa fa-print"></i> Print</a>
                            <div
                                className="text-xl-center"><strong>&nbsp;Terms and Conditions were accepted
                                on:&nbsp;</strong>{this.invoice.termsAndConditionsAcceptedDate}
                            </div>
                            <Button variant="secondary" className="rea-floatRight rea-cancelBtn"
                                    onClick={this.cancelTermsAndConditions}>
                                Cancel
                            </Button>
                        </div>
                        }
                    </Modal.Footer>
                </Modal>

                <div className="rea-invoiceContainer rea-block-row">
                    <div className="rea-block-12 rea-padding-0">
                        <div class="rea-sectionHeaders">Invoice Details</div>
                    </div>
                    <div className="rea-block-12 rea-padding-0">
                        <div className="custom-control custom-checkbox">
                            {!this.state.termsAndConditionsAccepted &&
                            <input type="checkbox" className="custom-control-input" id="customCheck1"
                                   onClick={this.showAcceptTermsAndConditionsPopup}
                            />
                            }
                            {!this.state.termsAndConditionsAccepted &&
                                <label className="custom-control-label" htmlFor="customCheck1"><span
                                className="rea-textLink">I accept
                                the Terms and Conditions </span></label>
                            }
                        </div>
                        {this.state.termsAndConditionsAccepted &&
                        <label  onClick={this.showAcceptTermsAndConditionsPopup}> <span
                            className="rea-textLink">Terms and Conditions accepted</span></label>
                        }
                    </div>
                    <div className="rea-block-12 rea-padding-0">
                        <div className="rea-block-row">
                            <div className="rea-block-12">
                                <div className="rea-block-12 rea-padding-0 rea-invoiceDetailsBtns">
                                    {this.invoice.invoiceLinkUrl &&
                                    <a className="btn wth2-ui-btn rea-viewInvoiceBtn"
                                       href={this.invoice.invoiceLinkUrl}><i
                                        className="fa fa-file-text"></i> View Invoice</a>
                                    }
                                    {this.showItineraryButton && this.invoice.itineraryLinkUrl &&
                                    <a className="btn wth2-ui-btn rea-viewItineraryBtn"
                                       href={this.invoice.itineraryLinkUrl} target="_blank" rel="noopener noreferrer"><i
                                        className="fa fa-map-marker"></i> View Itinerary</a>
                                    }
                                </div>
                                {this.showInvoiceDisclaimer &&
                                <div className="rea-block-12 rea-padding-0 rea-invoiceDisclaimer">
                                    Summary reflects most current information and may not match invoice if changes
                                    occurred since invoice generation date.
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    cancelTermsAndConditions = (event) => {
        // document.getElementById('customCheck1').focus();
        this.setState({showTermsAndConditionsPopup: false})
    }

    handleSubmit = (event) => {
        event.preventDefault();
        console.log('Accepting terms and conditions...');
        this.setState({acceptTermsAndConditionsButtonDisabled: true});
        //let invoice = this.props.invoice;
        const url = this.invoice.termsAndConditionsAcceptanceUrl + '&from=css';
        fetch(url, {
            method: 'GET',
            payload: {}
        }).then(paymentResponse => {
            if (paymentResponse.status === 200) {
                this.setState({acceptTermsAndConditionsButtonDisabled: false});
                console.log('Terms and Conditions accepted.');
                this.setState({termsAndConditionsAccepted: true})
                this.setState({showTermsAndConditionsPopup: false})
            } else {
                console.log('There was an error accepting terms and conditions')
                this.setState({acceptTermsAndConditionsButtonDisabled: false});
            }
        }).catch(error => {
            console.log('There was an error accepting terms and conditions')
            this.setState({acceptTermsAndConditionsButtonDisabled: false});
        });
    }

    showAcceptTermsAndConditionsPopup = (event) => {
        this.setState({showTermsAndConditionsPopup: true})
    }

    openPrintVersion = (event) => {
        const termsAndConditionsMarkup = this.invoice.termsAndConditionsMarkup;
        let newWindow = window.open('about:blank');
        if (newWindow) {
            newWindow.document.write(termsAndConditionsMarkup);
        }
    }
}

export default InvoiceDetails;
